import React from 'react'

function Notfound() {
  return <div>Notfound</div>
}

export default Notfound
